export const notifications = {
   notifications: "Notifications",
   sms: "SMS",
   email: "Email",
   notif: "Push Notification",
};
